var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-user-agent.js
// module id = 64
// module chunks = 0